<div class="mt-4 max-w-[500px]">
    <div class="!pl-6 text-[20px]">
        {{title}}
    </div>
    <div mat-dialog-content>
        <p [innerHTML]="content"></p>
    </div>
    <br/>
    <div class="pl-6 pr-6 mb-6">
        <app-action-buttons
            [buttonOneTitle]="'Cancel'"
            [buttonTwoTitle]="confirmButtonTitle"
            [justify]="'justify-end'"
            (onButtonOneClick)="handleCancel()"
            (onButtonTwoClick)="handleConfirm()"
        >
        </app-action-buttons>
    </div>
</div>
